import { createSelector } from '@reduxjs/toolkit';
import type { TRootState } from 'src/store/store-types';

export const selectCompareEstimates = (state: TRootState) => state.entities.compareEstimates;

export const selectCompareEstimatesList = createSelector([selectCompareEstimates], ({ list }) => list);

export const selectCompareEstimatesActiveCompare = createSelector([selectCompareEstimatesList], (list) =>
  list.find((item) => item?.active),
);

export const selectCompareEstimatesItems = createSelector([selectCompareEstimates], ({ estimates }) => estimates);

export const selectCompareEstimatesActiveEstimates = createSelector(
  [selectCompareEstimatesItems, selectCompareEstimatesActiveCompare],
  (estimates, activeCompare) => estimates.filter((estimate) => estimate?.compareId === activeCompare?.compareId),
);

export const selectIsLoadingCompareEstimates = createSelector(
  [selectCompareEstimates],
  ({ isFetching, isAdding, isGeneratingEstimates, isRecalculating }) =>
    isFetching || isAdding || isGeneratingEstimates || isRecalculating,
);

export const selectIsFetchingCompareEstimates = createSelector(
  [selectCompareEstimates],
  ({ isFetching }) => isFetching,
);

export const selectCompareEstimatesDesigns = createSelector([selectCompareEstimates], ({ designs }) => designs);

export const selectIsAddingCompareEstimates = createSelector([selectCompareEstimates], ({ isAdding }) => isAdding);
